import React from "react";
import BlogTwentySix from "../component/BlogTwentySix";

function BlogTwentySixContainer() {
  return <BlogTwentySix />;
}
export default BlogTwentySixContainer;
